/**
 * Wspólna stylizacja okien modalnych budżetu w stylu Noty
 * (powierzchnia, obramowanie, fioletowy cień, zaokrąglenie).
 */
export const budgetDialogPaperProps = {
  sx: {
    borderRadius: "8px",
    background: "#fdf8fd",
    border: "1px solid #c9c5d0",
    boxShadow: "0px 0px 15px 3px rgba(93, 73, 199, 0.3)",
    overflow: "hidden",
  },
};
